import React, { FC } from "react";
import IconButton from "@mui/material/IconButton";
import { AppIconsAdd } from "../../../components/AppIcons";
import OfferOrderDetailsProps from "../../../components/Basket/OrderOffer/OfferOrderDetailsProps";
import { Table, TableBody, TableRow, TableCell, Typography } from "@mui/material";
import IconMenuWithTooltip from "../../../components/Basket/upload/IconMenuWithTooltip";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from "../../../../explorer/hooks/useTranslation";

interface OrderOfferAddPartsToBasketProps {
    details: OfferOrderDetailsProps;
    onAddToExistingCart: (offerCode: string) => void;
    onAddToNewCart: (offerCode: string) => void;
}

export const OrderOfferAddPartsToBasket: FC<OrderOfferAddPartsToBasketProps> = ({ details, onAddToExistingCart, onAddToNewCart }) => {

    const {t} = useTranslation();

    const handleNewBasket = () => {
        onAddToNewCart(details.offerCode || details.orderCode || "NO CODE");
    };

    const handleExistingBasket = () => {
        onAddToExistingCart(details.offerCode || details.orderCode || "NO CODE");
    };
    
    const menuItems = [
        {
            label: t("orderOffer.addToNewBasket"),
            onClick: handleNewBasket,
        },
        {
            label: t("orderOffer.addToExistingBasket"),
            onClick: handleExistingBasket,
        },
    ];

    return (
        <IconMenuWithTooltip
            icon={<MoreVertIcon />}
            menuItems={menuItems}
        
        />
    );
};

